import Vue from "vue";
import Requests from "@/constants/Requests";
import store from "@/store";

const OfferService = {
  fetchList: (page) => {
    let isLoggedIn = store.getters["user/loggedIn"];

    let params = new URLSearchParams();
    params.append("page", page);
    params.append("page_count", 50);
    // params.append(
    //   "availability_date",
    //   store.getters["user/profile"].availability_date ||
    //   new Date().toISOString().slice(0, 10)
    // );
    params.append(
      "availability_date",
      store.getters["user/profile"].availability_date ? (store.getters["user/profile"].availability_date < new Date().toISOString().slice(0, 10) ? new Date().toISOString().slice(0, 10) : store.getters["user/profile"].availability_date) : new Date().toISOString().slice(0, 10)
    );
    params.append("patient", "1");

    return Vue.prototype.$http.get(
      Requests.offer[isLoggedIn ? "list" : "anonymousList"] +
      "?" +
      params.toString()
    );
  },
  fetchDetails: id => {
    return Vue.prototype.$http.get(Requests.offer.details.replace("{id}", id));
  },
  favorites: (orderBy, sortDir) => {
    let params = new URLSearchParams();
    params.append("order-by", orderBy);
    params.append("sort-dir", sortDir);

    return Vue.prototype.$http.get(Requests.offer.favorite.list, {
      params: params
    });
  },
  toggleFavorite: id => {
    return Vue.prototype.$http.post(Requests.offer.favorite.toggle, {
      offer_id: id
    });
  },
  toggleCustomer: id => {
    return Vue.prototype.$http.post(Requests.offer.toggleCustomer, {
      customer_id: id
    });
  },
  saveFilters: filters => {
    return Vue.prototype.$http.post(Requests.filters.update, filters);
  },
  fetchFilters: () => Vue.prototype.$http.get(Requests.filters.list),
  resetFilters: () => Vue.prototype.$http.get(Requests.filters.resetFilters)
};

export { OfferService };
